module.exports = __webpack_public_path__ + "static/media/product.bd240b25.svg";